module.exports = __webpack_public_path__ + "img/wrong-otp.0d19b8ae.svg";